import React, { useEffect, useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { addFourniture, editFourr } from "../JS/actions/fournitures";

const AddFourr = () => {
  const [fourniture, setFourniture] = useState({});
  const [edit, setEdit] = useState(false);
  const fourrToEdit = useSelector(
    (state) => state.fournitureReducers.fourniture
  );
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    if (params.id) {
      setEdit(true);
    } else {
      setEdit(false);
    }
    edit
      ? setFourniture(fourrToEdit)
      : setFourniture({
          title: "",
          description: "",
          qte: "",
        });
  }, [params, edit, fourrToEdit]);

  const handleChange = (e) => {
    setFourniture({ ...fourniture, [e.target.name]: e.target.value });
  };
  const handleSave = (e) => {
    e.preventDefault();
    if (edit) {
      dispatch(editFourr(params.id, fourniture, history));
      alert("founiture updated succesfully :)");
    } else {
      dispatch(addFourniture(fourniture, history));
      alert("founiture added succesfully :)");
    }
  };
  return (
    <div>
      <Form className="addFamily">
        <h1 style={{ textAlign: "center", color: "black" }}>
          {" "}
          Ajouter une Founiture{" "}
        </h1>

        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label>Nom fourniture</Form.Label>
            <Form.Control
              onChange={handleChange}
              type="text"
              placeholder="Entrez le nom"
              name="title"
              required
              value={fourniture.title}
            />
          </Form.Group>

          <Form.Group as={Col}>
            <Form.Label> Desription</Form.Label>
            <Form.Control
              onChange={handleChange}
              type="text"
              placeholder="Description"
              name="description"
              required
              value={fourniture.description}
            />
          </Form.Group>
        </Row>
        <Form.Group as={Col}>
          <Form.Label>Qte</Form.Label>
          <Form.Control
            onChange={handleChange}
            type="number"
            placeholder="qte"
            name="qte"
            required
            value={fourniture.qte}
          />
        </Form.Group>
        {/* <Form.Group as={Col} controlId="formGridState">
          <Form.Label>Type event</Form.Label>
          <Form.Select
            onChange={handleChange}
            placeholder="Type event"
            name="eventType"
            type="text"
            defaultValue="Choose..."
            required
          >
            <option>Choisir...</option>
            <option>evennement</option>
            <option>action</option>
          </Form.Select>
        </Form.Group> */}

        <Row className="mb-3"></Row>

        <Button
          onClick={handleSave}
          style={{ marginBottom: "15px" }}
          variant="primary"
          type="submit"
        >
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default AddFourr;
